export const headerTitleName = (currentUser, headerTitle, headerAdminTitle = 'Admin centre') => {
  if (currentUser.IsAdmin && window.location.href.indexOf('admin/admincentre') > 0) {
    return headerAdminTitle
  }
  return headerTitle
}



// WEBPACK FOOTER //
// ./src/utils/headerTitleName.js